import { useMemo } from 'react'

import { GetOrganizationHomePageQuery, GetOrganizationHomePageQueryVariables } from 'types/graphql'

import { QueryKey, useQuery } from '../utils/queryClient'

const GetOrganizationHomePage = gql`
  query GetOrganizationHomePageQuery($slug: String!) {
    organizationBySlug(slug: $slug) {
      ...OrganizationHomePageFragment
    }
  }
`

export const useOrganizationHomePageQuery = (slug: string | undefined) => {
  const res = useQuery<GetOrganizationHomePageQuery, GetOrganizationHomePageQueryVariables>({
    queryKey: [QueryKey.OrganizationInspectionInformation, slug],
    queryDocument: GetOrganizationHomePage,
    variables: { slug: slug ?? '' },
    enabled: !!slug,
  })

  const organization = useMemo(() => res.data?.organizationBySlug ?? null, [res.data])

  return {
    ...res,
    organization,
  }
}
